import {StoreStateShape} from '@/redux/store/storeStateTypes';

const activeMeetingsCountSelector = ({activeMeetings: {activeMeetingsCount}}: StoreStateShape) => activeMeetingsCount;

const activeMeetingsSelector = ({
    activeMeetings: {
        loadingHandler: {getActiveMeetingsLoading},
        data,
    },
}: StoreStateShape) => ({
    getActiveMeetingsLoading,
    data,
});

const userIdSelector = ({commonUserDataReducer}: StoreStateShape) => commonUserDataReducer?.employment?.id;

const callsSelector = ({commonUserDataReducer}: StoreStateShape) => ({
    awsConnectAgentStatus: commonUserDataReducer?.phoneCallData?.awsConnectAgentStatus || 'Offline',
    email: commonUserDataReducer?.user?.email,
});

const isVideoCallsEnabledSelector = ({commonUserDataReducer}: StoreStateShape) => ({
    isVideoCallsEnabled: Boolean(commonUserDataReducer?.features?.CapabilityVideoCalls),
});

export {
    activeMeetingsCountSelector,
    activeMeetingsSelector,
    callsSelector,
    isVideoCallsEnabledSelector,
    userIdSelector,
};
